// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"999fb2c7","239":"36acb329","453":"3340652a","732":"be2598db"}[chunkId] + ".chunk.js";
};